import { Injectable } from "@snap/ts-inject";
import { lensCoreFactory } from "../../lens-core-module/loader/lensCoreFactory";
import type { LensCore } from "../../lens-core-module/lensCore";
import { getLogger } from "../../logger/logger";
import type {
    AnalyticsEventsHandler as LensCoreAnalyticsEventsHandler,
    LensAnalytics as LensCoreLensAnalytics,
    LensAnalyticsEvent as LensCoreLensAnalyticsEvent,
    CreatorAnalyticsEvent as LensCoreCreatorAnalyticsEvent,
    CameraType as LensCoreCameraType,
} from "../../lens-core-module/generated-types";
import { lensAnalyticEventsHandlerFactory } from "./lensAnalyticEventsHandler";

const logger = getLogger("registerLensAnalyticEventsHandler");

/**
 * @internal
 */
export type AnalyticsEventsHandler = LensCoreAnalyticsEventsHandler;

/**
 * @internal
 */
export type LensAnalytics = LensCoreLensAnalytics;

/**
 * @internal
 */
export type LensAnalyticsEvent = LensCoreLensAnalyticsEvent;

/**
 * @internal
 */
export type CreatorAnalyticsEvent = LensCoreCreatorAnalyticsEvent;

/**
 * @internal
 */
export type CameraType = LensCoreCameraType;

/**
 * @internal
 *
 * Hooks to the LensCore analytics events. See Built-In.AnalyticsSystem JS API.
 *
 * This allows consumers to send Lens analytics events to external metrics systems.
 */
export const registerLensAnalyticEventsHandler = Injectable(
    "registerLensAnalyticsHandler",
    [lensCoreFactory.token, lensAnalyticEventsHandlerFactory.token],
    (lensCore: LensCore, lensAnalyticsHandler: AnalyticsEventsHandler) => {
        // Make sure we are compatible with previous LensCore versions
        if (!lensCore.setAnalyticsEventsHandler) {
            logger.warn("Current LensCore version doesn't support lens analytics events.");
            return;
        }
        lensCore.setAnalyticsEventsHandler(lensAnalyticsHandler);
    }
);
